import { MAP_TYPES } from '@deck.gl/carto';

const BROWARDFUTURELANDUSE_SOURCE_ID = 'browardFutureLandUseSource';

const source = {
  id: BROWARDFUTURELANDUSE_SOURCE_ID,
  type: MAP_TYPES.TABLE,
  connection: 'bmpo-smartmetro-09142026',
  data: `us-con-gcp-npr-0000424-011325.diamond.Broward_County_Future_Land_Use`,
};

export default source;
